module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('a', {
    attrs: {
      "id": "p14"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-weight": "bold",
      "font-family": "arial"
    }
  }, [_c('span', {
    staticClass: "color-FF5100"
  }, [_vm._v("Grilling Basics")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("Grilling is an art. Each time you fire up the barbecue is different. You’ll need to feel out the hot spots and rotate the food to and from those areas so everything will be done at the same time. Remember, the grill doesn’t do the cooking. You do the cooking. The grill just gets hot.")])]), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "p14"
    }
  }), _c('a', {
    attrs: {
      "id": "title6"
    }
  }, [_c('h1', {
    staticClass: "title-section1 color-FF5100 font-GoudyHeavyfaceBT-Regular-3_1-11_75"
  }, [_vm._v("How Hot is Hot?")]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-13"
  }, [_vm._v("If you’re using a gas grill, you can simply turn the knob to the desired setting. With charcoal it’s a bit trickier. The best way should be familiar from your touch football days. Simply hold your hand about 3 inches over the grilling grate and count Mississippis until the heat forces you to pull your hand away.")]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image color-3C1C00 font-AtmaSerif-MediumRoman-5_1-13"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "e9780811866989_i0009.jpg",
      "src": "images/e9780811866989_i0009.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p-br color-3C1C00"
  }, [_c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-13"
  }, [_vm._v("3 Mississippis = medium-hot fire "), _c('br'), _vm._v("2 Mississippis = hot fire "), _c('br'), _vm._v("1 Mississippi = ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumItalic-6_1-13"
  }, [_vm._v("very ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-13"
  }, [_vm._v("hot fire")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-13"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-13"
  }, [_vm._v("For a kettle-style grill, a tightly packed single layer of coals will usually yield a medium-hot fire. Adding about a third more coals will make a hot fire.")])]), _c('div', {
    staticClass: "section2"
  }, [_c('a', {
    attrs: {
      "id": "title6"
    }
  }), _c('a', {
    attrs: {
      "id": "title7"
    }
  }, [_c('h1', {
    staticClass: "title-section2 color-3C1C00 font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("Here are some tips to keep in mind:")]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("1. ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-13"
  }, [_vm._v("Wait for the coals to heat up. Coals achieve optimum heat when they are completely ashed over, usually about 20 minutes after lighting. If you are grilling any appetizers, you may need to add more coals to the pile before grilling the main course.")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-13"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("2. ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-13"
  }, [_vm._v("For gas grills, don’t forget the gas. Nothing is more humiliating than watching your flame sputter out and fail just as the steaks hit the grill. (And dads, they don’t yet make a little blue pill to solve this problem.)")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-13"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("3. ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-13"
  }, [_vm._v("Know when to use the cover. Most cooking on a gas grill is done with the cover down. With charcoal, it depends on what you’re grilling. For steaks, burgers, or any cut of meat, poultry, or fish requiring a short time over a hot fire, cook with the cover off. Anything cooked slowly off the heat will require the grill to be covered. Always position the vents on the cover over the food—this draws the heat and smoke to that side of the grill. Use the cover of your charcoal grill briefly to keep flare-ups under control—covering the grill for 10 seconds or so should put out the flames.")])])]), _c('a', {
    attrs: {
      "id": "p15"
    }
  }, [_c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-13"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("4. ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-13"
  }, [_vm._v("Keep your grill clean. The best way to do this is to use a wire brush right after you finish cooking. The cooking grate is hot, and the grease will come off easily. Maintaining a clean grill is not just a fussy step that you can ignore—it prevents the food from sticking to the grate.")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-13"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("5. ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-13"
  }, [_vm._v("Use tongs or a spatula to turn food on the grill. Never use a fork, which only serves to release the precious juices from the meat.")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-13"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("6. ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-13"
  }, [_vm._v("Apply sauces or marinades to meat during the last few minutes of cooking to keep from burning them.")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-13"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("7. ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-13"
  }, [_vm._v("The platter you use to bring the uncooked food to the grill is ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumItalic-6_1-13"
  }, [_vm._v("not ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-13"
  }, [_vm._v("the platter you use to bring the cooked food to the table unless you ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumItalic-6_1-13"
  }, [_vm._v("wash it well ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-13"
  }, [_vm._v("with hot, soapy water. It’s always best to have two platters, one designated for the raw food and one designated for serving. That way, when the chicken is ready to come off the grill, you are not scrambling around for a serving platter and being tempted to say, “What the heck—I’ll use the one I brought the chicken out on—just one time won’t hurt anybody.”")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-13"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-10"
  }, [_vm._v("8. ")]), _c('span', {
    staticClass: "font-AtmaSerif-MediumRoman-5_1-13"
  }, [_vm._v("Always make a little more than you think you’ll need. Somehow, food fresh from the grill has a way of disappearing.")])])])])]), _c('a', {
    attrs: {
      "id": "p15"
    }
  }, [_c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "box-grey saut_fullpage"
  }, [_c('h1', {
    staticClass: "title-box-grey color-FFFFFF font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("POP CULTURE")]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle-box-grey color-FFFFFF font-GoudyHeavyfaceBT-Regular-3_1-14"
  }, [_vm._v("Don’t Start the Party Without Me")]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-FFFFFF"
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-9_5"
  }, [_vm._v("THERE WAS A PERIOD ")]), _c('span', {
    staticClass: "font-AvantGarde-Medium-9_1-8"
  }, [_vm._v("when my 10-year-old was having a very hard time falling asleep. It wasn’t monsters keeping him up. It was just the opposite. He couldn’t sleep because he was convinced that once he conked out, I and his mom and his older brother would break out the champagne and root beer and chocolate cake and start having a party.")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-FFFFFF"
  }, [_c('span', {
    staticClass: "font-AvantGarde-Medium-9_1-8"
  }, [_vm._v("“I hate being the youngest,” he would say, forcing his eyes to stay open. “It’s totally unfair!”")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-FFFFFF"
  }, [_c('span', {
    staticClass: "font-AvantGarde-Medium-9_1-8"
  }, [_vm._v("He’d managed to convince himself that ice cream sundaes of mammoth proportions were being consumed as soon as he closed his eyes. That the three of us would play cards, hold marathon Monopoly games, put on the CD of ")]), _c('span', {
    staticClass: "font-AvantGarde-MediumObl-10_1-8"
  }, [_vm._v("West Side Story ")]), _c('span', {
    staticClass: "font-AvantGarde-Medium-9_1-8"
  }, [_vm._v("and act out all the parts. All without him! We never went to bed. Our night was one long celebration. Not only that, but LeBron would just happen to stop by, along with Tintin and Snowy and Ronaldinho, the soccer star.")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-FFFFFF"
  }, [_c('span', {
    staticClass: "font-AvantGarde-Medium-9_1-8"
  }, [_vm._v("It didn’t matter that if he snuck out of bed and surreptitiously checked on us, he found only his brother studying French, his mom doing her reading for her book group, and me in the kitchen finishing up the last of the dishes from dinner. That, too, was just another trick, as in the Sinatra movie ")]), _c('span', {
    staticClass: "font-AvantGarde-MediumObl-10_1-8"
  }, [_vm._v("Robin and the Seven ")]), _c('span', {
    staticClass: "font-AvantGarde-MediumObl-10_1-8"
  }, [_vm._v("Hoods")]), _c('span', {
    staticClass: "font-AvantGarde-Medium-9_1-8"
  }, [_vm._v(", when the casino magically transforms into a library whenever the cops show up.")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-FFFFFF"
  }, [_c('span', {
    staticClass: "font-AvantGarde-Medium-9_1-8"
  }, [_vm._v("“You all can’t wait for me to fall asleep,” he would declare, “so you can start having fun!”")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-FFFFFF"
  }, [_c('span', {
    staticClass: "font-AvantGarde-Medium-9_1-8"
  }, [_vm._v("And all I could do was smile and say to him, “Son, I only wish it were true.”")])])])])])]), _c('a', {
    attrs: {
      "id": "p15"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9c8918c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/008chapter03.vue
// module id = 78
// module chunks = 0